import classNames from "classnames";
import React from "react";

const AccordionItem = ({ id, heading, children, initiallyOpen = true }) => {
	return (
		<div className="accordion-item">
			<p className="accordion-header" id={`${id}-heading`}>
				<button
					className="accordion-button fs-5 mb-1 text-uppercase bg-white text-body"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target={`#${id}`}
					aria-expanded={initiallyOpen ? "true" : "false"}
					aria-controls={id}
				>
					{heading}
				</button>
			</p>
			<div
				id={id}
				className={classNames("accordion-collapse collapse", {
					show: initiallyOpen,
				})}
				aria-labelledby={`${id}-heading`}
			>
				<div className="accordion-body">{children}</div>
			</div>
		</div>
	);
};

export default AccordionItem;
